export const EXPOSED_CREDENTIALS_HELP_ARTICLE_URL =
  'https://help.mentimeter.com/en/articles/8480355-creating-an-account-with-potentially-leaked-login-credentials';
